import { createLoadableComponent } from '../../infrastructure/code-splitting/utils/LoadableComponentFactory';

export default createLoadableComponent(
  () =>
    import(
      /* webpackPrefetch: true */
      './containers/TravelerDetailsGraphqlContainer'
    ),
);
